// extracted by mini-css-extract-plugin
export default {"section":"Section_section__7PoKG","title":"Section_title__H9e+4","contentBox":"Section_contentBox__vRl2K"};